<template>
	<div class="view-wrapper">
		<div class="row">
			<div class="col-12 col-sm-6">

				<b-card header-tag="h5" header="Currency" class="mb-3">
				</b-card>

			</div>

			<div class="col-12 col-sm-6">

				<b-card header-tag="h5" header="Weight" class="mb-3">
				</b-card>
			</div>
		</div>

		<div class="row">
			<div class="col">

				<b-card header-tag="h5" header="Equipped Items" class="mb-3">
				</b-card>

			</div>
		</div>
		
		<div class="row">
			<div class="col">

				<b-card header-tag="h5" header="Augmentations" class="mb-3">
				</b-card>

			</div>
		</div>

		<div class="row">
			<div class="col">

				<b-card header-tag="h5" header="Magic Items" class="mb-3">
				</b-card>

			</div>
		</div>

		<div class="row">
			<div class="col">

				<b-card header-tag="h5" header="Stored Items">
				</b-card>

			</div>
		</div>

	</div>
</template>

<script>
export default {
	
}
</script>

<style scoped>

</style>